import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-w', 'LetterW', [["path",{"d":"M8 7v10l3.75-5 3.75 5V7","key":"svg-0"}]]);